import React, { memo } from 'react';

const GuestList = ({ guests }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">👨‍👩‍👧‍👦 Who's Coming When</h2>
      {guests.map((guest, idx) => (
        <div key={idx} className="bg-white/90 dark:bg-gray-800/90 backdrop-blur rounded-lg shadow-md p-4 border border-orange-100 dark:border-gray-700">
          <h3 className="font-semibold text-lg dark:text-gray-100">{guest.name}</h3>
          <p className="text-gray-700 dark:text-gray-300">{guest.dates}</p>
          <p className="text-sm text-gray-500 dark:text-gray-400">{guest.from}</p>
        </div>
      ))}
    </div>
  );
};

export default memo(GuestList);